/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { Navbar, Nav, NavItem} from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import PropTypes from 'prop-types';
import { updateComponent, getFromJson } from '../../util/Utils'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/header.css';
import Logo from './Logo';
var homepage = require('../../../package.json').homepage;


function makeMta(state) {
    let mta = getFromJson(state, ['data', 'data', 'mta'])
    return {
        product: mta && mta.product ? mta.product.name + '\u2122 v' + mta.product.version  : '',
        host: mta ? mta.fullHostName : ''
    }
} 


/**
 * A component that serves as the page header.  Mainly consists of product
 * branding (name/logo) and links for navigation.
 */
export default class Header extends Component {
    static propTypes = {
        showError: PropTypes.func.isRequired
    };


    constructor(props) {
        super(props)
        this.makeDocumentTitle = this.makeDocumentTitle.bind(this);
    }


    makeDocumentTitle(state) {
        let title = 'PowerMTA Web Monitor'
        if (state) {
            let host = getFromJson(state, ['data', 'data', 'mta', 'fullHostName'])
            if (host) {
                return `(${host}) ${title}`
            }
        }
        return title
    }


    componentDidMount() {
        updateComponent(this, '/status').then(() => {
            document.title = this.makeDocumentTitle(this.state)
        })
    }


    render() {
        let data = makeMta(this.state)
        return (
            <Navbar expand='md'>
                <Navbar.Brand>
                    <Logo/>
                </Navbar.Brand>
                <Nav>
                    <LinkContainer to={homepage + "/"} exact>
                        <NavItem>
                            Home
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/status"} exact>
                        <NavItem>
                            Status
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/queues"} exact>
                        <NavItem>
                            Queues
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/domains"} exact>
                        <NavItem>
                            Domains
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/vmtas"} exact>
                        <NavItem>
                            Virtual MTAs
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/jobs"} exact>
                        <NavItem>
                            Jobs
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/logs"} exact>
                        <NavItem>
                            Logs
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/command"} exact>
                        <NavItem>
                            Command
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/enterLak"} exact>
                        <NavItem>
                            License
                        </NavItem>
                    </LinkContainer>
                    <LinkContainer to={homepage + "/config"} exact>
                        <NavItem>
                            Configuration
                        </NavItem>
                    </LinkContainer>
                </Nav>
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        { data.product }
                        <br/>
                        { data.host }
                    </Navbar.Text>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}
